import { Injectable } from '@angular/core';
import { RequestMethod } from '@angular/http';
import { Observable, } from 'rxjs/Observable';
import { ConfigService } from './config.service';
import { Tenant } from './../config.types';

@Injectable()
export class TenantsService extends ConfigService {
  //-------------------------------------------------------------------------------------------------------------------
  /**
   * make secured api-request für tenants list and returns observer 
   */
  loadTenants(): Observable<Tenant[]> {
    return this.secureRequest(RequestMethod.Get, 'config/tenant');
  }
  //-------------------------------------------------------------------------------------------------------------------
  /**
   * make secured api-request für tenant details and returns observer 
   */
  loadTenant(id: Number): Observable<Tenant> {
    return this.secureRequest(RequestMethod.Get, 'config/tenant/'+id);
  }
  //-------------------------------------------------------------------------------------------------------------------
  /**
   * make secured api-request for updating tenant data or add new tenant
   * @param tenant 
   */
  saveTenant(tenant: Tenant): Observable<Tenant> {
    let response: Observable<Tenant>;
    // a) insert new tenant:
    if(tenant.id===null){
      response = this.secureRequest(RequestMethod.Post, 'config/tenant', tenant);
    }
    // b) update existing tenant:
    else {
      response = this.secureRequest(RequestMethod.Put, 'config/tenant/'+tenant.id, tenant);
    }
    return response;
  }
  //-------------------------------------------------------------------------------------------------------------------
  /**
   * make secured api-request to delete hostname entry (specified per host beause its unique)
   * @param host 
   */
  removeHostname(host: string): Observable<any> {
    let response: any;
    response = this.secureRequest(RequestMethod.Get, 'config/remove/hostname/'+host);
    return response;
  }
  //-------------------------------------------------------------------------------------------------------------------
  /**
   * make secured api-request to login as sysadmin of given tenant (specified per tenant code)
   * @param tenantCode 
   */
  loginAs(tenantCode: string): Observable<any> {
    let response: any;
    response = this.secureRequest(RequestMethod.Get, 'config/login/as/'+tenantCode);
    return response;
  }
  //-------------------------------------------------------------------------------------------------------------------
}


// WEBPACK FOOTER //
// ./src/app/config/services/tenants.service.ts